import React, { createContext, useState, useMemo } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [showForm, setShowForm] = useState(false);
  const [stockAdjustmentShowForm, setStockAdjustmentShowForm] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openDSR, setOpenDSR] = useState(false);
  const [dateDSR, setDateDSR] = useState(new Date());
  const [showPreviewDSR, setShowPreviewDSR] = useState(false);
  // Prevents every consumer (CartHeader, Fab, ...) from re-rendering on
  // every AppProvider render - only when one of these values actually changes.
  const value = useMemo(
    () => ({
      showForm,
      setShowForm,
      stockAdjustmentShowForm,
      setStockAdjustmentShowForm,
      openPaymentModal,
      setOpenPaymentModal,
      openDSR,
      setOpenDSR,
      dateDSR,
      setDateDSR,
      showPreviewDSR,
      setShowPreviewDSR,
    }),
    [showForm, stockAdjustmentShowForm, openPaymentModal, openDSR, dateDSR, showPreviewDSR]
  );
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
